export default __webpack_public_path__ + "static/media/cloud-upload-icon.c63b4e02.png";